// extracted by mini-css-extract-plugin
module.exports = {"strategy":"strategy_strategy__qZXQB","line":"strategy_line__3pwr4","open_frames":"strategy_open_frames__1ZzXj"};